<template>
    <div :id="$id('attribute')" class="hover-alternative">
        <Header :name="attribut.i18NName" :visible="isSomeSelected"
                :i18NPictureId="attribut.i18NPictureId"
                :i18NDescription="attribut.i18NDescription"
                size="sm" v-on:reset-elements="resetElements"/>

        <EingabeWerte ref="eingabeWerte" :attribut="attribut"  :group-name="$id('werte')" :gruppenName="gruppenName"/>
        <AuswahlWerte ref="auswahlWerte" :attribut="attribut"  :group-name="$id('werte')" :gruppenName="gruppenName"/>
        <div class="row flex-right" style="font-weight: bold; color: #b3b3b3; opacity: 0; min-height: 10px">
            <a v-if="kunde || anonym" style="cursor: pointer" v-on:click="triggerInquiryModal()" >{{$t('inquiry.inquiry')}}</a>
<!--            v-if="kunde || anonym"-->
        </div>
    </div>
</template>

<script>
    import EingabeWerte from "@/components/config-page/produktmerkmale/EingabeWerte";
    import AuswahlWerte from "@/components/config-page/produktmerkmale/AuswahlWerte";
    import Header from "@/components/config-page/utils/Header";

    export default {
        name: 'Attribut',
        components: {Header, EingabeWerte, AuswahlWerte},
        props: ['attribut', 'gruppenName'],
        computed: {
            isSomeSelected: function () {
                return (this.attribut.selectedEingabeWert !== null || this.attribut.selectedAuswahlWert !== null);
            },
            anonym: function() {
                return this.$store.getters.getUserData.anonym;
            },
            kunde: function() {
                return this.$store.getters.getUserData.kunde;
            }
        },
        methods: {
            resetElements() {
                let attribut = this.attribut;
                this.$store.commit('resetAttribut', {attribut: attribut});
            },
            triggerInquiryModal() {
                this.$store.dispatch('showInquiryModal')
                // this.$store.commit('setShowInquiryModal', true)
                // this.$emit('trigger-inquiry-modal');
            },
        }
    }
</script>

<style scoped>

    .hover-alternative:hover div {
        opacity: 1 !important;
    }


</style>